import lodash from 'lodash'
export default {
  getListChecklist (state, payload) {
    state.checklists = []
    payload.data.forEach(element => {
      state.checklists.push(element)
    })
    state.last_page = payload.meta ? payload.meta.last_page : 0
    state.total = payload.meta ? payload.meta.total : 0
  },
  getListChecklistAll (state, payload) {
    state.checklistAll = payload.data
  },
  showChecklist (state, payload) {
    state.checklist.checklist_info = payload
    state.checklist_permissions = payload.permissions
  },
  destroyChecklist (state, payload) {
    var index = lodash.findIndex(state.checklists, ['id', payload.id])
    state.checklists.splice(index, 1)
    state.total -= 1
  },
  duplicateChecklist (state, payload) {
    state.checklist.group_of_checklists = payload.grp_chk_items
  },
  selectCtg (state, payload) {
    var data = []
    payload.chks.forEach(element => {
      data = state.checklistAll.filter(function (item) {
        if (item.id === element && item.category.id !== payload.ctg.id) {
          console.log(item.category.id)
          // eslint-disable-next-line no-return-assign
          return item.category = payload.ctg
        }
        return item
      })
    })
    state.checklistAll = data
  }
}



// WEBPACK FOOTER //
// ./src/store/module/checklist/mutations.js